import { cn } from "@/lib/utils";

export function BackIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6 text-white", className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.75 8.25L10 12l3.75 3.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        height="23"
        rx="11.5"
        stroke="currentColor"
        strokeOpacity="0.5"
        width="23"
        x="0.5"
        y="0.5"
      />
    </svg>
  );
}

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[25px] text-white", className)}
      fill="none"
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        height="24"
        rx="12"
        stroke="currentColor"
        width="24"
        x="0.5"
        y="0.5"
      />
      <path
        d="M9.375 9.375l6.25 6.25m.001-6.25l-6.25 6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}
